import { render, staticRenderFns } from "./Purchase.vue?vue&type=template&id=ab9bfa1c&scoped=true&"
import script from "./Purchase.vue?vue&type=script&lang=js&"
export * from "./Purchase.vue?vue&type=script&lang=js&"
import style0 from "styles/views/orderAdmin/purchase.css?vue&type=style&index=0&id=ab9bfa1c&scoped=true&lang=css&"
import style1 from "./Purchase.vue?vue&type=style&index=1&id=ab9bfa1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9bfa1c",
  null
  
)

export default component.exports